import { useState } from 'react';
import { Progress, Typography, Collapse } from 'antd';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import ViabilityComponent from './viabilityComponent';
import documentsIcon from '../../../../assets/onboarding/documentsIcon.svg';
import documentsIconDesk from '../../../../assets/onboarding/fileIcon.svg';
import downloadIcon from '../../../../assets/onboarding/downloadIcon.svg';
import arrowNew from '../../../../assets/onboarding/arrowNew.svg';
import { isMobileOnly } from 'react-device-detect';

const { Text } = Typography;
const { Panel } = Collapse;

const Viability = ({ viabilityData, viabilityDocument, setChangesPages }) => {
	const [collapseOption, setCollapseOption] = useState(true);
	const { t } = useTranslation();

	const data = [
		{
			titulo: 'viability.financingCeilingTitle',
			viable:
				viabilityData && viabilityData.penalties
					? viabilityData.penalties['financingCeiling']
					: null
		},
		{
			titulo: 'viability.indebtednessTitle',
			viable:
				viabilityData && viabilityData.penalties ? viabilityData.penalties['indebtedness'] : null
		},
		{
			titulo: 'viability.seniorityTitle',
			viable: viabilityData && viabilityData.penalties ? viabilityData.penalties['seniority'] : null
		},
		{
			titulo: 'viability.incomesTitle',
			viable: viabilityData && viabilityData.penalties ? viabilityData.penalties['incomes'] : null
		},
		{
			titulo: 'viability.noresidentTitle',
			viable:
				viabilityData && viabilityData.penalties ? viabilityData.penalties['noresident'] : null
		}
	];

	let textViability;

	if (viabilityData && viabilityData.viability < 2) {
		textViability = t('viability.viabilityLessThan2');
	} else if (viabilityData && viabilityData.viability < 3 && viabilityData.viability >= 2) {
		textViability = t('viability.viabilityBetween2and3');
	} else if (viabilityData && viabilityData.viability < 4 && viabilityData.viability >= 3) {
		textViability = t('viability.viabilityBetween3and4');
	} else {
		textViability = t('viability.viabilityBetween4and5');
	}
	let textViabilitytitle;

	if (viabilityData && viabilityData.viability < 2) {
		textViabilitytitle = t('viability.viabilityLessThan2title');
	} else if (viabilityData && viabilityData.viability < 3 && viabilityData.viability >= 2) {
		textViabilitytitle = t('viability.viabilityBetween2and3title');
	} else if (viabilityData && viabilityData.viability < 4 && viabilityData.viability >= 3) {
		textViabilitytitle = t('viability.viabilityBetween3and4title');
	} else {
		textViabilitytitle = t('viability.viabilityBetween4and5title');
	}

	const penaltiesViability = () => {
		return data.map((values) => {
			return (
				<ViabilityComponent
					dataMortgage={{ houseState: 'have_decide' }}
					key={values.titulo}
					titulo={values.titulo}
					viable={values.viable}
					viabilityData={viabilityData}
					optionsModal={!isMobileOnly && true}
				/>
			);
		});
	};

	const downloadDocumentsMobile = (title, download) => {
		return (
			<div style={{ background: '#FFFFFF', margin: '0px -16px', padding: '12px 16px' }}>
				<a
					href={download}
					target={'_blank'}
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center'
					}}
					rel="noreferrer">
					<div
						style={{
							display: 'flex',
							alignItems: 'center'
						}}>
						<div style={{ display: 'flex', padding: 2 }}>
							<img src={documentsIcon} alt="documentsIcon" height={20} />
						</div>
						<Text style={{ fontSize: 16, fontWeight: 400, marginLeft: 16 }}>{t(title)}</Text>
					</div>
					<img src={downloadIcon} alt="downloadIcon" />
				</a>
			</div>
		);
	};
	const downloadDocumentsDesktop = (title, download) => {
		return (
			<div
				style={{
					marginBottom: 8,
					display: 'flex',
					alignItems: 'center'
				}}
				href={`${download}`}
				target={'_blank'}>
				<a href={download} target={'_blank'} rel="noreferrer">
					<img src={documentsIconDesk} alt="documentsIcon" />
					<Text
						style={{
							fontSize: 12,
							fontWeight: 400,
							marginLeft: 8,
							color: '#748EA0'
						}}>
						{t(title)}
					</Text>
				</a>
			</div>
		);
	};

	return (
		<>
			{!isMobileOnly && (
				<div style={{ width: 880, margin: 'auto' }}>
					<Collapse
						className={isMobileOnly && 'collapse-viability-onboarding'}
						defaultActiveKey={[]}
						ghost
						onChange={(e) => setCollapseOption(e.length === 1 ? false : true)}
						style={{
							marginBottom: collapseOption && 26
						}}>
						<Panel
							showArrow={false}
							header={
								<div
									style={{
										display: 'flex',
										marginTop: 24,
										alignSelf: 'center',
										justifyContent: 'center'
									}}>
									<div
										style={{
											borderBottom: '1px solid #006DFF',
											display: 'flex'
										}}>
										<div
											style={{
												fontSize: '16px',
												fontWeight: '600'
											}}>
											{t('__sabadell-es__onboarding.discoverYourViability')}
										</div>
										<img
											src={arrowNew}
											alt="arrowNew"
											style={{
												height: 24,
												marginLeft: '15px',
												transition: 'transform .2s ease-out',
												transform: collapseOption !== false ? 'rotate(0deg)' : 'rotate(180deg)'
											}}
										/>
									</div>
								</div>
							}
							key="1">
							<div className="viability-card-new" style={{ display: 'flex' }}>
								<Progress
									type="dashboard"
									strokeColor={viabilityData?.viability < 2 ? '#F0A21D' : '#239D45'}
									trailColor={'#E0E0E0'}
									percent={(viabilityData && viabilityData.viability * 100) / 5}
									format={() => (
										<div>
											<Text
												strong
												style={{
													fontSize: '32px',
													color: '#212121',
													marginBottom: '4px',
													display: 'grid'
												}}>
												{viabilityData ? numeral(viabilityData.viability).format('0.0') : null}
											</Text>
											<Text style={{ fontSize: '14px', color: '#212121' }}>{`de 5`}</Text>
										</div>
									)}
									width={120}
									className="EstimatedViabilityProgress"
									style={{
										textAlign: 'center',
										marginRight: 0
									}}
								/>
								<div style={{ marginLeft: 24 }}>
									<div className="EstimatedViabilityParagraphB" style={{ marginBottom: 16 }}>
										<Text
											style={{
												fontSize: '24px',
												height: '72px',
												color: viabilityData && viabilityData.viability < 2 ? '#F0A21D' : '#239D45',
												fontWeight: '700'
											}}>
											{textViabilitytitle}{' '}
										</Text>
									</div>
									<div
										className="onboarding-viability-description"
										dangerouslySetInnerHTML={{
											__html: textViability
										}}
									/>

									{!isMobileOnly && (
										<div
											style={{
												display: 'flex',
												columnGap: 16,
												marginTop: 16,
												alignSelf: 'center'
											}}>
											{downloadDocumentsDesktop('viability.feasibilityAnalysis', viabilityDocument)}
										</div>
									)}
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									marginTop: 30,
									justifyContent: 'center',
									flexFlow: 'wrap'
								}}>
								{penaltiesViability()}
							</div>

							<div
								style={{
									background: '#FFFFFF',
									borderRadius: 4,
									padding: 24,
									margin: '32px 0px'
								}}>
								<div
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: '#757575'
									}}
									onClick={() => setChangesPages()}
									className="description-link"
									dangerouslySetInnerHTML={{
										__html: t('onboarding.cityzenshipDescription')
									}}
								/>
							</div>
						</Panel>
					</Collapse>
				</div>
			)}

			{isMobileOnly && (
				<Collapse
					className={isMobileOnly && 'collapse-viability-onboarding'}
					defaultActiveKey={[]}
					ghost
					onChange={(e) => setCollapseOption(e.length === 1 ? false : true)}
					style={{
						marginBottom: collapseOption && 26
					}}>
					<Panel
						showArrow={false}
						header={
							<div
								style={{
									display: 'flex',
									alignSelf: 'center',
									justifyContent: 'center'
								}}>
								<div
									style={{
										borderBottom: '1px solid #006DFF',
										display: 'flex'
									}}>
									<div
										style={{
											fontSize: '16px',
											fontWeight: '600'
										}}>
										{t('__sabadell-es__onboarding.discoverYourViability')}
									</div>
									<img
										src={arrowNew}
										alt="arrowNew"
										style={{
											height: 24,
											marginLeft: '15px',
											transition: 'transform .2s ease-out',
											transform: collapseOption !== false ? 'rotate(0deg)' : 'rotate(180deg)'
										}}
									/>
								</div>
							</div>
						}
						style={{ background: '#f5f5f5' }}
						key="1">
						<div
							className={isMobileOnly ? 'Estimated-Viability-onboarding' : 'EstimatedViabilityB'}>
							<Progress
								type="dashboard"
								strokeColor={viabilityData?.viability < 2 ? '#F0A21D' : '#52C41A'}
								trailColor={'#E0E0E0'}
								percent={(viabilityData && viabilityData.viability * 100) / 5}
								format={() => (
									<div>
										<Text
											strong
											style={{
												fontSize: '32px',
												color: '#212121',
												marginBottom: '4px',
												display: 'grid'
											}}>
											{viabilityData ? numeral(viabilityData.viability).format('0.0') : null}
										</Text>
										<Text style={{ fontSize: '14px', color: '#212121' }}>{`de 5`}</Text>
									</div>
								)}
								width={120}
								className="EstimatedViabilityProgress"
								style={{
									textAlign: 'center',
									marginRight: 0
								}}
							/>
							<div className="EstimatedViabilityParagraphB" style={{ textAlign: 'center' }}>
								<Text
									style={{
										fontSize: '16px',
										height: '72px',
										color: viabilityData && viabilityData.viability < 2 ? '#F0A21D' : '#52C41A',
										fontWeight: '700'
									}}>
									{textViabilitytitle}{' '}
								</Text>
							</div>
							<div style={{ backgroundColor: '#FFFFFF', margin: '24px -16px 0px' }}>
								<div
									style={{
										display: 'flex',
										marginTop: '-5px',
										justifyContent: 'center',
										flexFlow: 'wrap',
										padding: 16
									}}>
									{penaltiesViability()}
								</div>
							</div>
							<div
								style={{
									borderRadius: 4,
									padding: 24,
									margin: '32px 0px'
								}}>
								<div
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: '#757575'
									}}
									onClick={() => setChangesPages()}
									className="description-link"
									dangerouslySetInnerHTML={{
										__html: t('onboarding.cityzenshipDescription')
									}}
								/>
							</div>
							{downloadDocumentsMobile('viability.feasibilityAnalysis', viabilityDocument)}
						</div>
					</Panel>
				</Collapse>
			)}
		</>
	);
};

export default Viability;
